import React from 'react';
import { describe } from 'react-desc';
import AddonWrapper from './AddonWrapper.js';
import { props } from './props.js';
import { defaultProps } from './defaultProps.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';

var DSInputGroup = function DSInputGroup(_ref) {
  var containerProps = _ref.containerProps,
      innerRef = _ref.innerRef,
      className = _ref.className,
      style = _ref.style,
      leftAddon = _ref.leftAddon,
      rightAddon = _ref.rightAddon,
      InputComponents = _ref.children;
  return /*#__PURE__*/React.createElement(AddonWrapper, {
    ref: innerRef,
    className: className,
    containerProps: containerProps,
    leftAddon: leftAddon,
    rightAddon: rightAddon,
    style: style
  }, InputComponents);
};

DSInputGroup.propTypes = props;
DSInputGroup.defaultProps = defaultProps;
var DSInputGroupWithSchema = describe(DSInputGroup);
DSInputGroupWithSchema.propTypes = props;

export default DSInputGroup;
export { DSInputGroupWithSchema };
//# sourceMappingURL=DSInputGroup.js.map
